var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProSub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.295929,
    y: 0.200806,
    width: 18.0506,
    height: 37.1041,
    fill: "#036185"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18.3464,
    y: 0.200806,
    width: 19.0534,
    height: 37.1041,
    fill: "#64BCD2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 18.3464,
    y: 18.2513,
    width: 19.0534,
    height: 19.0534,
    fill: "#C4EFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProSub);
export default __webpack_public_path__ + "static/media/proSub.84becc23747de281df443a8f0bbb4fa6.svg";
export { ForwardRef as ReactComponent };